<template>
	<div class="toast-container position-fixed end-0 p-3" style="top: 60px; z-index: 1800">
		<div id="toast-success" class="toast toast-copilot align-items-center" role="alert" aria-live="assertive" aria-atomic="true" data-bs-dismiss="toast" aria-label="Close">
			<div class="d-flex">
				<div class="toast-body">
					<i class="fa-solid fa-circle-check"></i>
					{{ toast.toastMessage }}
				</div>
			</div>
		</div>

		<div id="toast-warning" class="toast toast-warning align-items-center" role="alert" aria-live="assertive" aria-atomic="true" data-bs-dismiss="toast" aria-label="Close">
			<div class="d-flex">
				<div class="toast-body">
					<i class="fa-solid fa-triangle-exclamation text-warning"></i>
					{{ toast.toastMessage }}
				</div>
			</div>
		</div>

		<div id="toast-error" class="toast toast-danger align-items-center" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="d-flex">
				<div class="toast-body text-white">
					<i class="fa-solid fa-triangle-exclamation"></i>
					{{ toast.toastMessage }}
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>
	</div>
</template>

<script>
import * as bootstrap from 'bootstrap'
import { mapGetters } from 'vuex'
import { hideAllModals } from '@/utils'
import store from '@/store'

export default {
	name: 'ToastWelcom',
	emits: [],
	computed: {
		...mapGetters('copilot', ['toast'])
	},
	mounted() {
	},
	beforeUnmount() {
	},
	watch: {
		toast(newValue) {
			if (newValue.showToast === true) {
				this.showToast()
				hideAllModals()
				store.commit('copilot/setIsShowToastScanQr', { isShowToastScanQr: null })
			}
			if (newValue === false) {
				this.showToast('scannerIncorrectly')
				store.commit('copilot/setIsShowToastScanQr', { isShowToastScanQr: null })
			}
		}
	},
	methods: {
		showToast() {
			const id = this.toast?.idToast || "toast-success";
			const toastElement = document.getElementById(id);
			if (!toastElement) return;
			const toastInstance = bootstrap.Toast.getOrCreateInstance(toastElement);
			toastInstance.show();
		}
	}
}
</script>
